import { Body, Heading, Icon, type IconType } from '@assembly-js/design-system';
import React from 'react';

interface SettingsEmptyStateProps {
  icon: IconType;
  title: string;
  description: string;
  /** Usually the button that creates the first item. */
  action?: React.ReactNode;
}

/**
 * Stands in for a group's card while it has nothing to list. A page the plan
 * doesn't include draws the same card through SettingsLockedCard, so every
 * empty and gated state in settings shares one spec.
 */
export const SettingsEmptyState = ({
  icon,
  title,
  description,
  action,
}: SettingsEmptyStateProps) => (
  <div className="flex flex-col items-center gap-1 rounded-[4px] bg-white px-6 py-12 text-center shadow-[inset_0_0_0_1px_var(--color-gray-200)]">
    <div className="mb-2 grid h-10 w-10 place-items-center rounded-[4px] bg-gray-100 text-secondary">
      <Icon icon={icon} className="h-4.5 w-4.5" />
    </div>
    <Heading
      size="base"
      tag="h3"
      className="mb-0! text-[15px] leading-[22px] font-medium text-black-heading"
    >
      {title}
    </Heading>
    <Body
      size="sm"
      tag="div"
      className="max-w-[340px] leading-5 text-secondary"
    >
      {description}
    </Body>
    {action && <div className="mt-3">{action}</div>}
  </div>
);
